import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Router } from "@angular/router";
import { LoginService } from "app/services/login.service";

import { Profissao } from "app/model";

import { API, ITENSPORPAGINA } from "app/app.config";
import { CLIENT_ID } from "app/app.config";

@Injectable()
export class ProfissaoService {
    constructor(
        private http: HttpClient,
        private router: Router,
        private login: LoginService
    ) {}

    buscarPorParametro(param: string, pagina: Number): Observable<any> {
        const headers = new HttpHeaders().set("noloader", "t");

        if (param.length > 0) {
            return this.http.get<any>(
                `${API}/api/Profissao/list/${param.trim()}?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}`,
                { headers: headers }
            );
        } else {
            return this.http.get<any>(`${API}/api/Profissao?Pagina=${pagina}&ItensPorPagina=3000`, {
                headers: headers,
            });
        }
    }

    buscarPorId(id: number): Observable<any> {
        return this.http.get<any>(`${API}/api/Profissao/${id}?Pagina=1&ItensPorPagina=${ITENSPORPAGINA}`);
    }

    remover(id: Number): Observable<any> {
        return this.http.delete<any>(`${API}/api/Profissao/${id}`);
    }

    salvar(profissao: Profissao): Observable<any> {
        if (profissao.Id > 0) {
            return this.http.put<any>(`${API}/api/Profissao/${profissao.Id}`, profissao);
        } else {
            return this.http.post<any>(`${API}/api/Profissao/`, profissao);
        }
    }
}
